import $ from 'jquery';

export default {
    init() {

    },
    finalize() {
        if (filterActivated) {
            setTimeout(() => {
                $("html, body").animate({scrollTop: $('#resources').offset().top - 85}, 1500);
            }, 100)
        }
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/resources.js